"use client";

import { useGSAP } from "@gsap/react";
import { TextTriadType } from "../../../sanity/lib/types/textTriad";

import gsap from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(useGSAP);

type Props = TextTriadType;

export const TextTriad = (props: Props) => {
    useGSAP(() => {
        gsap.set(".text-triad-block", { y: "100%", opacity: 0 });

        gsap.to(".text-triad-block", {
            y: 0,
            opacity: 1,
            scrollTrigger: {
                trigger: ".text-triad-section",
                start: "top 70%",
                toggleActions: "play none none none",
            },
            stagger: 0.4,
        });
    });

    return (
        <section className="container text-triad-section">
            {props.title && (
                <h2 className="m-body-l md:d-body-l mx-2.5 md:mx-5 pt-2.5 pb-4 md:py-5">
                    {props.title}
                </h2>
            )}

            {props.textBlock.map((block, index) => (
                <div key={index} className="pt-5 pb-20 border-t md:pb-25 text-triad-block">
                    <div className="grid grid-cols-12 mx-2.5 md:mx-5 gap-5">
                        <h3 className="col-span-12 md:col-span-5 m-headline-2 md:d-headline-2 whitespace-break-spaces">
                            {block.triadTitle}
                        </h3>
                        <p className="col-span-12 md:col-start-7 md:col-span-6 m-body-l md:d-body-l whitespace-break-spaces">
                            {block.text}
                        </p>
                    </div>
                </div>
            ))}
        </section>
    );
};
